import { bindContributionProvider, createContributionProvider } from "../../../common/contribution-provider";

import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasAreaRender } from "./area-render";

import { DefaultBaseInteractiveRenderContribution } from "./contributions";

import { AreaRenderContribution } from "./contributions/constants";

import { AreaRender, GraphicRender } from "./symbol";

const loadedAreaModuleContexts = new WeakSet;

export function bindAreaRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedAreaModuleContexts, bind) || (bind(DefaultCanvasAreaRender).toDynamicValue((({container: container}) => new DefaultCanvasAreaRender(createContributionProvider(AreaRenderContribution, container)))).inSingletonScope(), 
    bind(AreaRender).toService(DefaultCanvasAreaRender), bind(GraphicRender).toService(AreaRender), 
    bind(AreaRenderContribution).toService(DefaultBaseInteractiveRenderContribution), 
    bindContributionProvider(bind, AreaRenderContribution));
}

export const areaModule = bindAreaRenderModule;
//# sourceMappingURL=area-module.js.map
